import React from 'react'
import CommingSoon from '../../CommingSoon/CommingSoon'
// import ProjectTemplate from '../ProjectTemplate/ProjectTemplate'
export default function HTML(props) {
  return (
    <>
      {/* <ProjectTemplate name='HTML'/> */}
      <CommingSoon />
    </>
  )
}
